export default __webpack_public_path__ + "static/media/74t.12d3c84e.jpg";